module.exports = __webpack_public_path__ + "img/Bitmap@512x (1).328d8b53.png";